export function columnsToExcelHeaders(columns: any) {
    return (columns.filter((column: any) => column.hasOwnProperty("simpleHeader") && column.showInDownload).map((column: any) => column.simpleHeader))
}

export function rowsToData(columns: Array<any>, rows: Array<any>, sort: (a: any, b: any) => number) {
    const filteredColumns = columns.filter((column: any) => (column.hasOwnProperty("simpleHeader") && column.showInDownload));
    rows = rows.map((row: any) => filteredColumns.map((column: any) => column.accessor(row)));
    rows = rows.sort(sort);
    return rows;
}